<template>
    <section class="page-block-section">
        <header
            :class="headerClasses"
            class="page-block-section__header"
            v-if="title.length && !noHeader">

            <component 
                class="page-block-section__title" 
                :class="titleClasses"
                :is="headingTag">
                {{ title }}
            </component>

            <HelpButton
                class="page-block-section__help-button"
                v-if="tooltipTitle || tooltipContent"
                :container="container"
                :title="tooltipTitle"
                :content="tooltipContent" />

            <span class="page-block-section__counter" v-if="counter">{{ counter }}</span>

            <div class="page-block-section__title-button">
                <slot name="title-button"></slot>
            </div>

        </header>

        <p v-if="caption.length" class="page-block-section__caption">{{ caption }}</p>

        <div v-if="!hideContent"
            class="page-block-section__content"
            :class="contentClasses">
            <slot ></slot>
        </div>
    </section>
</template>
<script>
import HelpButton from '@/components/ui/HelpButton'

export default {
    name: 'PageBlockSection',
    components: {
        HelpButton
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        caption: {
            type: String,
            default: ''
        },
        container: {
            type: String,
            default: null
        },
        tooltipTitle: {
            type: String,
            default: ''
        },
        tooltipContent: {
            type: String,
            default: ''
        },
        counter: {
            type: [Number, String],
            default: ''
        },
        noPaddingHeader: {
            type: Boolean,
            default: false
        },
        contentVisible: {
            type: Boolean,
            default: false
        },
        hideContent: {
            type: Boolean,
            default: false
        },
        noHeader: {
            type: Boolean,
            default: false
        },
        contentPadding: {
            type: Boolean,
            default: false
        },
        contentMargin: {
            type: Boolean,
            default: false
        },
        biggestTitle: {
            type: Boolean,
            default: false
        },
        bigTitle: {
            type: Boolean,
            default: true
        },
        headingTag: {
            type: String,
            default: 'h2'
        }
    },
    computed: {
        titleClasses() {
            return {
                'page-block-section__title_big': this.bigTitle,
                'page-block-section__title_biggest': this.biggestTitle,
            }
        },
        contentClasses() {
            return {
                'page-block-section__content_padding': this.contentPadding,
                'page-block__content_visible': this.contentVisible
            }
        },
        headerClasses() {
            return {
                'page-block-section__header_no_padding': this.noPaddingHeader
            }
        }
    }
}
</script>
<style lang="less">
.page-block-section {
    --header-margin-bottom: rem(8);
    --content-margin-bottom: 0;
    --content-color: @color-black;

    background-color: @color-white;

    @{desktop} & {
        --header-margin-bottom: rem(10);
    }

    &__header {
        display: flex;
        align-items: center;

        color: @color-black;

        margin-bottom: var(--header-margin-bottom);
        padding-top: rem(8);
        padding-bottom: rem(4);

        .page-padding();

        &_no_padding {
            padding-right: 0;
            padding-left: 0;
        }
    }

    &__header_no_padding ~ &__caption {
        padding-left: 0;
    }

    &__title {
        font-size: rem(15);
        font-weight: 500;

        margin-bottom: 0;

        &-button {
            margin-left: auto;
        }

        &_big {
            font-size: rem(16);
        }

        &_biggest {
            font-size: rem(18);
        }
    }

    &__caption {
        color: @color-gray;
        font-size: rem(13);

        margin-top: rem(-4);
        margin-bottom: rem(10);

        .page-padding();

        @{desktop} & {
            max-width: rem(320);
        }
    }

    &__content {
        color: var(--content-color);

        margin-bottom: var(--content-margin-bottom);

        &_padding {
            .page-padding();
        }

        &_visible {
            overflow: visible;
        }
    }

    &__help-button {
        margin-left: rem(6.5);

        position: relative;
        top: rem(-0.5);
    }

    &__counter {
        font-weight: 500;
        line-height: 1.2;

        margin-top: rem(1);
        margin-left: auto;

        transform: translateY(rem(1));
    }

    & + & {
        margin-top: rem(26);

        @{desktop} & {
            margin-top: rem(29);
        }
    }
}
</style>
